import Layout from "@/components/Layout";
import EventsList from "@/components/EventsList";

export default function Events() {
  return (
    <Layout>
      <div className="mb-6">
        <div className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-2">School calendar</div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100" style={{ fontFamily: "Outfit" }}>Events</h1>
        <p className="text-slate-500 dark:text-slate-400 mt-1">Upcoming and past school events for this year.</p>
      </div>
      <EventsList />
    </Layout>
  );
}
